import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight, Clock, ShieldCheck } from "lucide-react";
import { useI18n } from "../../i18n/I18nProvider";

export default function NeuchatelLocal() {
  const { t } = useI18n();
  return (
    <section data-testid="neuchatel-section" className="py-24 sm:py-32 bg-white border-t border-zinc-200">
      <div className="container-oj">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 rounded-full border border-oj-brand/40 bg-oj-brand/10 px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.2em] text-oj-deep">
              <MapPin className="size-3.5" /> {t("neuchatel.eyebrow")}
            </div>
            <h2 className="font-display mt-5 text-balance text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95] text-oj-ink">
              {t("neuchatel.title_a")} <span className="bg-oj-brand text-oj-ink px-3 rounded-md">{t("neuchatel.title_b")}</span><br />
              {t("neuchatel.title_c")}
            </h2>
            <p className="mt-5 max-w-xl text-lg text-zinc-600 leading-relaxed">
              {t("neuchatel.desc")}
            </p>
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
              <Stat icon={Clock} label={t("neuchatel.stat_response")} value={t("neuchatel.stat_response_value")} />
              <Stat icon={MapPin} label={t("neuchatel.stat_onsite")} value={t("neuchatel.stat_onsite_value")} />
              <Stat icon={ShieldCheck} label={t("neuchatel.stat_hosted")} value={t("neuchatel.stat_hosted_value")} />
            </div>
            <div className="mt-10 flex flex-wrap gap-3">
              <Link
                to="/contact"
                data-testid="neuchatel-contact-cta"
                className="inline-flex items-center gap-1.5 bg-oj-deep text-white font-semibold px-6 py-3.5 rounded-md hover:bg-oj-ink transition-colors"
              >
                {t("neuchatel.cta_talk")} <ArrowUpRight className="size-4" />
              </Link>
              <Link
                to="/callback"
                className="inline-flex items-center gap-1.5 border border-zinc-300 hover:border-zinc-900 text-oj-ink font-semibold px-6 py-3.5 rounded-md transition-colors"
              >
                {t("neuchatel.cta_callback")}
              </Link>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative rounded-2xl border border-zinc-200 bg-zinc-50 p-8 overflow-hidden">
              <div className="absolute inset-0 technical-grid pointer-events-none opacity-60" />
              <div className="relative">
                <div className="flex items-center gap-2">
                  <span className="h-2 w-2 rounded-full bg-oj-brand animate-pulse" />
                  <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">{t("neuchatel.hq_label")}</span>
                </div>
                <div className="mt-6 font-display text-6xl sm:text-7xl font-black tracking-tighter text-oj-deep leading-[0.9]">
                  {t("neuchatel.hq_name")}
                </div>
                <div className="mt-4 text-sm text-zinc-600">
                  {t("neuchatel.geo_line")}
                </div>
                <div className="mt-8 grid grid-cols-2 gap-3 text-sm">
                  <div className="rounded-md bg-white border border-zinc-200 p-3">
                    <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">{t("neuchatel.hours_label")}</div>
                    <div className="mt-1 font-semibold text-oj-ink">{t("neuchatel.hours_value")}</div>
                  </div>
                  <div className="rounded-md bg-white border border-zinc-200 p-3">
                    <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">{t("neuchatel.langs_label")}</div>
                    <div className="mt-1 font-semibold text-oj-ink">{t("neuchatel.langs_value")}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-xl border border-zinc-200 p-4 bg-zinc-50/60">
      <div className="flex items-center gap-2">
        <Icon className="size-4 text-oj-brand" />
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">{label}</span>
      </div>
      <div className="mt-1 font-display text-xl font-bold text-oj-ink">{value}</div>
    </div>
  );
}
